import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-8">
      <div className="w-full max-w-md border border-border bg-card p-10 text-center animate-fade-up">
        <XCircle size={48} className="mx-auto mb-4 text-muted-foreground" />
        <h1 className="font-display text-2xl font-bold">Paiement annulé</h1>
        <p className="mt-2 text-sm text-muted-foreground">Aucun montant n'a été débité. Vous pouvez réessayer à tout moment.</p>
        <button onClick={() => navigate("/facturation")} data-testid="cancel-back" className="mt-6 bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90">
          Retour aux factures
        </button>
      </div>
    </div>
  );
}
